import { useAuthStore } from '~/stores/auth';
import { useBootstrapStore } from '~/stores/bootstrap';
import { parseAccessListCanonical } from '~/utils/accessList';

// public path ที่ทุกคนเข้าได้ (ไม่ check AccessList)
const PUBLIC_PATHS = new Set<string>([
  '/',
  '/home',
  '/login',
  '/register',
  '/no-permission',
  '/v2',
  '/v2/',
]);

// /v2/<path>  ->  AccessList key
const ROUTE_ACCESS_MAP: Record<string, string> = {
  '/v2/pos': 'pos',
  '/v2/expense': 'expense',
  '/v2/stock': 'stock',
  '/v2/reports': 'report',
  '/v2/menu': 'menu',
  '/v2/settings': 'setting',
  '/v2/edit-bill' : 'report'
};

// Normalize the user's AccessList to canonical tokens before matching so BOTH the
// legacy singular (`expense`, `setting`) and the SPA's old plural (`expenses`,
// `settings`) forms are honored. ROUTE_ACCESS_MAP keys are already canonical.
function parseAccessList(raw: unknown): string[] {
  return parseAccessListCanonical(raw);
}

export default defineNuxtRouteMiddleware((to) => {
  const bootstrapStore = useBootstrapStore();
  const authStore = useAuthStore();

  // public หรือ owner mobile route ผ่าน
  if (PUBLIC_PATHS.has(to.path) || to.path.startsWith('/v2-owner-report-mobile')) {
    return;
  }

  // bootstrap ยังไม่เสร็จ อย่าเพิ่ง check
  if (!bootstrapStore.loaded) {
    return;
  }

  // ยังไม่มี user
  if (!authStore.user) {
    return navigateTo('/login');
  }

  // ไม่อยู่ใน access map = ไม่ต้อง gate
  const requiredKey = ROUTE_ACCESS_MAP[to.path];
  if (!requiredKey) return;

  const { AccessList, Role } = authStore.user as any;

  // Role 2 = admin → เข้าได้ทุกหน้า ไม่ต้อง check AccessList
  if (Role === 2) return;

  // Role อื่น (เช่น 1 = staff) → check AccessList
  const accessArray = parseAccessList(AccessList);
  if (accessArray.includes(requiredKey)) return;

  return navigateTo('/no-permission');
});
